var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnterLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9999 26.9V11H35.1999V26.9C35.1999 28.2075 34.2074 29.2 32.8999 29.2H13.7999V27H32.8999C32.9432 27 32.967 26.9925 32.9761 26.9889C32.9801 26.9873 32.9838 26.9851 32.9838 26.9851C32.9838 26.9851 32.9868 26.981 32.9888 26.9762C32.9924 26.9671 32.9999 26.9433 32.9999 26.9Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6364 26.5082L21.0364 18.4082L22.5635 19.9918L14.1737 28.082C14.142 28.1154 14.1294 28.1499 14.126 28.1737C14.137 28.1834 14.1479 28.1933 14.1585 28.2034L22.5585 36.2034L21.0413 37.7966L12.67 29.8239C11.6119 28.9341 11.7581 27.3862 12.6221 26.5222L12.6364 26.5082Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterLight);
export default __webpack_public_path__ + "static/media/icon_enter_light.fa3c0cf0.svg";
export { ForwardRef as ReactComponent };